import axios from 'axios';
import { getValidToken } from './authService';
import { isDemoMode, demoGetProfile } from '../demo/demoStore';

const API_URL = process.env.REACT_APP_API_URL;


const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(async (config) => {
  const token = await getValidToken(); 
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export const getProfile = async () => {
  if (isDemoMode()) return demoGetProfile();
  const response = await apiClient.get('/profile');
  return response.data;
};

export const createProfile = async (profileData) => {
  if (isDemoMode()) return Promise.resolve({ success: true });
  const response = await apiClient.post('/profile', profileData);
  return response.data;
};

export const updateProfile = async (id, profileData) => {
  if (isDemoMode()) return Promise.resolve({ success: true });
  const response = await apiClient.put(`/profile/${id}`, profileData);
  return response.data;
};